import React, {useState, useEffect, useRef}  from 'react';
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../layout/Layout";

import { useropen } from '../../redux/userInfo';
import { open, close } from '../../redux/popupSlice';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import Input from '../../component/Input';
import Button from '../../component/Button';
import Radios from '../../component/Radios';

import { getMemberinfo, regPhone, patternPwCker } from "../../utils/utils";

export default function StoretypeFinsub({ navigation }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const [memberinfos, setmemberinfos] = useState(''); 
    const [Arrs, setArrs] = useState([
        {titles: '상호', comments: location?.state?.title},
        {titles: '등록번호', comments: location?.state?.permit_number},
        {titles: '대표', comments: location?.state?.ceo},
    ]); 
    useEffect(() => {
        getMemberinfo(setmemberinfos);
    }, []);
    useEffect(() => {
        dispatch(
            useropen({
                userdata: {login: true}
            })
        );   
    }, []);
        
    useEffect(() => {
        console.log("memberinfos", memberinfos);
        const { compony, application } = memberinfos;
        setArrs([
            {titles: '상호', comments: application?.title},
            {titles: '등록번호', comments: application?.permit_number},
            {titles: '대표', comments: application?.ceo},
        ]);
    }, [memberinfos]);
    return(
        <>
        <Layout header={false}>
            <div className='normalform' >
                {memberinfos?.application?.status*1 === 99 ? 
                <div className='normalform_title'>소속 신청 거부되었습니다.</div>
                :
                <div className='normalform_title'>소속 신청이 완료되었습니다.</div>
                }
                
                
                <div className='normaltableview'>
                    {Arrs?.map((x, i) => {
                        return (
                            <div>
                                <div>{x?.titles}</div>
                                <div>{x?.comments}</div>
                            </div>
                        );
                    })}
                </div>
                {memberinfos?.application?.status*1 === 99 ? 
                    <div className='normalform_comment' style={{ marginTop: 20, whiteSpace: 'pre-wrap' }}>
                        대표공인중개사 회원이 신청을 거부하였습니다.
                    </div>
                :
                <>
                    <div className='normalform_comment' style={{ marginTop: 20 }}>대표공인중개사 회원이 마이페이지 &gt; 직원관리 메뉴에서 </div>
                    <div className='normalform_comment' >신청을 승인하시면 서비스 이용이 가능합니다.</div>
                </>
                }

                {memberinfos?.application?.status*1 === 99 &&
                <div className='loginbutton' style={{ marginTop: 20 }}>
                    <Button
                        onPress={() => {
                            navigate('/Storetype2Write', {state: {registerName: memberinfos?.name }});
                        }}
                        buttonTxt={'소속 재신청 하기'}
                    />
                </div>   
                }   

  
            </div>            
        </Layout>
        </>
    )
}

